module.exports = __webpack_public_path__ + "static/media/contactmask.8a9d05b9.png";